import { fetchPersea } from "@/config/axios/config-axios";

export const getAppMonitorStatus = async (params = {}) => {
    return await fetchPersea('/monitor/page/status', 'GET', { cache: false, ...params });
};